export const CLIENT_URI = process.env.REACT_APP_CLIENT_URI
export const SERVER_URI = process.env.REACT_APP_SERVER_URI
export const API_BASE_URL = process.env.API_BASE_URL
export const API_SPACE_ID = process.env.API_SPACE_ID
export const API_TOKEN = process.env.API_TOKEN
export const PRODUCT_FREE =  process.env.REACT_APP_PRODUCT_FREE
export const PRODUCT_PREMIUM = process.env.REACT_APP_PRODUCT_PREMIUM
export const PRODUCT_PREMIUM_ID = process.env.REACT_APP_PRODUCT_PREMIUM_ID